import { AxiosCacheMiddlewareConfig } from "../axiosCustomService/services/CacheDatabase/interface";

export const MINUTE = 60000;

export const cacheConfig: AxiosCacheMiddlewareConfig = {
    rules: [
        { urlPattern: /api\/CCM\/Jobs\/GetAppointmentTimeTypes/, cacheDuration: 60 * MINUTE }, // Cache for 1 hour
        { urlPattern: /api\/StoredProcedures\/sp_ServiceAgreements_GetValidCampaignCodes/, cacheDuration: 60 * MINUTE }, // Cache for 1 hour
        { urlPattern: /api\/Agreements\/GetPlanCostAfterOffers/, cacheDuration: 60 * MINUTE, autoGenerateKey: true, }, // Cache for 1 hour
        { urlPattern: /api\/CCM\/Costs\/GetAvailableOffers/, cacheDuration: 60 * MINUTE, autoGenerateKey: true, }, // Cache for 1 hour
    ],
};